<template>
    <div class="erpsku-input">
        <Poptip trigger="focus" v-if="multiple">
            <Input class="erpsku-input-input" v-model="erpSku" v-bind="inputProps" :readonly="showread=='showyes' ?false:true" @on-blur="handlesearch">
                <Icon type="ios-search" style="font-size: 16px; margin-right: 10px; cursor: pointer;" slot="suffix" @click="handleShowERPSKU" />
            </Input>
            <div slot="content">{{erpSku || "多个可按逗号分隔输入，如erpsku1,erpsku2"}}</div>
        </Poptip>
        <Input v-else class="erpsku-input-input" v-model="erpSku" v-bind="inputProps" :readonly="showread=='showyes' ?false:true" @on-blur="handlesearch">
            <Icon type="ios-search" style="font-size: 16px; margin-right: 10px; cursor: pointer;" slot="suffix" @click="handleShowERPSKU" />
        </Input>
        <compModal v-model="modalProps.show" v-bind="modalProps">
            <compErpSku :isManage="erpskutype == 'manage'" :multiple="multiple" @on-data="handleSelectERPSKU" @on-close="modalProps.show = false"></compErpSku>
        </compModal>
    </div>
</template>
<script>
import compErpSku from './erpsku.vue';
export default {
    props: {
        value: {
            type: String
        },
        inputProps: {
            type: Object
        },
        showread:String,
        erpskutype:String,
        multiple: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    components: {
        compErpSku,
    },
    watch: {
        value: {
            immediate: true,
            handler (val) {
                console.log('改变erpsku', val)
                this.erpSku = val;
            },
        }
    },
    data () {
        return {
            row: {},
            erpSku: '',
            modalProps: {
                show: false,
                showFooter: false,
                title: this.$t('erp.product.product_query', { defaultValue: '产品查询' }),
                width: 1000
            }
        }
    },
    mounted() {
        // this.bus.$on("changereset", value => {
        //     if(value === 'reset'){
        //         this.erpSku = ''
        //     }

        // });
	},
    methods: {
        handleShowERPSKU () {
            this.modalProps.show = true;
        },
        handlesearch(){
            if (this.multiple) {
                if (Array.isArray(this.erpSku)) {
                    this.$emit("on-data", this.erpSku);
                }
                else {
                    this.$emit("on-data", this.erpSku.split(","));
                }
            }
            else {
                this.$emit('on-data', {erpSku:this.erpSku});
            }
        },
        handleSelectERPSKU (row) {
            console.log("handleSelectERPSKU", row)
            // 多选模式下返回数组
            if (this.multiple) {
                // this.$set(this.$data, 'row', row);
                this.modalProps.show = false;
                // this.row = row;
                this.erpSku = row;
                // this.value = this.erpSku;
                this.$emit('on-data', row);
                this.$emit('on-change', row);
            }
            else {
                this.$set(this.$data, 'row', row);
                this.modalProps.show = false;
                this.row = row;
                this.erpSku = row.erpSku;
                // this.value = this.erpSku;
                this.$emit('on-data', row);
                this.$emit('on-change', row.erpSku);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.erpsku-input {
    display: inline-block;
    width: 100%;

    &-input {
        width: 100%;
    }
}
</style>